<template>
  <div>
    <MultiMonthPicker
      ref="dateComponentRef"
      v-model="searchText"
      class="customgrid-date-bar"
      :label="$t('month')"
      @input="onSearch"
      clearable
      multiple
    />
  </div>
</template>

<script>
import { eventBus } from "@/main";
import MultiMonthPicker from "../widget/MultiMonthPicker.vue";
export default {
  data() {
    return {
      searchText: null,
    };
  },
  props: {
    columnHeader: String,
    onCustomEvent: Function,
  },
  mounted() {
    if (sessionStorage.getItem("salesMonth")) {
      this.searchText = sessionStorage.getItem("salesMonth").split(",");
    }
    eventBus.$on("clear-filters", this.clearFilters);
  },
  methods: {
    clearFilters() {
      this.searchText = null;
      const columnHeader = this.params.columnHeader;

      if (columnHeader == "salesMonth") {
        sessionStorage.removeItem("salesMonth");
      }
    },
    onSearch() {
      let searchText = this.searchText;
      const columnHeader = this.params.columnHeader;
      if (searchText != null) {
        if (
          columnHeader == "salesMonth" &&
          searchText !== undefined &&
          searchText !== null
        ) {
          sessionStorage.setItem("salesMonth", searchText);
        } else {
          sessionStorage.removeItem("salesMonth");
        }
        this.$parent.$listeners.onFilterChanged(columnHeader, searchText);
      }
    },
  },
};
</script>
